/**
 *
 * DeleteElectronicPurseModal
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 30-Nov-2022
 */

import React from 'react';
import PortalModal from 'Components/PortalModal/PortalModal';
import formattedMessages from '../../modules/languageModule';
import PropTypes from 'prop-types';
import style from './DeleteEPursePopup.scss';

const DeleteElectronicPurseModal = (props) => (
	<PortalModal
		title={formattedMessages.warningTitle}
		subtitle={formattedMessages.subtitleDelete}
		subtitleValues={formattedMessages.deleteSubtitle}
		actions={{ handleClose: () => {} }}
		buttons={[
			{
				variant: 'outlined',
				onClick: props.actions.closeModal,
				contentText: formattedMessages.abortLabelButton,
			},
			{
				variant: 'contained',
				onClick: () => props.actions.deleteItem(props.payload),
				contentText: formattedMessages.confirmLabelButton,
				isLoading: props.isLoading,
			},
		]}
	/>
);

DeleteElectronicPurseModal.propTypes = {
	actions: PropTypes.objectOf(PropTypes.func),
	isLoading: PropTypes.bool,
	payload: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
};

DeleteElectronicPurseModal.defaultProps = {
	// Add here some default propTypes values
};

export default DeleteElectronicPurseModal;
